import { render, staticRenderFns } from "./Pizza.vue?vue&type=template&id=43a06796&scoped=true"
import script from "./Pizza.vue?vue&type=script&lang=js"
export * from "./Pizza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a06796",
  null
  
)

export default component.exports